<loading [loading]="loading.isShow" [loadingMessage]="loading.message"></loading>

<div class="admin-page settings" *ngIf="!loading.isShow">
  <ng-container *ngIf="error_messages.length > 0">
    <ng-container *ngFor="let error_message of error_messages">
      <div class="alert alert-danger">
        <button type="button" class="close" data-dismiss="alert" (click)="removeErrorMessage(error_message)">
          ×
        </button>
        {{ error_message }}
      </div>
    </ng-container>
  </ng-container>
  <!--<span class="error-msg" *ngIf="isSomethingWrong">Something went wrong - try again!</span>-->

  <div class="settings__block">
    <div class="settings__header">
      <h3 class="page-title settings__cap">Document storage</h3>
    </div>

    <div class="settings__body">
      <p *ngIf="isUserHasAccess">
        <label>
          <input
            class="slds-checkbox"
            type="radio"
            name="org-admin-settings"
            value="dont-save"
            [(ngModel)]="pushbackChoice"
          />
          &nbsp;Don’t save documents on Salesforce
        </label>
        <br />
        <label>
          <input
            class="slds-checkbox"
            type="radio"
            name="org-admin-settings"
            value="save-as-attachment"
            [(ngModel)]="pushbackChoice"
          />
          &nbsp;Save documents on Salesforce as Attachments
        </label>
        <br />
        <label>
          <input
            class="slds-checkbox"
            type="radio"
            name="org-admin-settings"
            value="save-as-file"
            [(ngModel)]="pushbackChoice"
          />
          &nbsp;Save documents on Salesforce as Files
        </label>
        <br />
        <button class="btn btn-sm btn-primary ml-0" (click)="updateAdminSettings()">Save</button>
        <br />
        <span class="success-msg" *ngIf="isUpdateChanges">Successfully updated Administrator Settings!</span>
      </p>
      <p *ngIf="!isUserHasAccess">Pushback control requires an administrator profile.</p>
    </div>
  </div>

  <div class="settings__block layouts">
    <div class="settings__header layouts__header">
      <h3 class="settings__cap layouts__title">SignNow buttons</h3>
    </div>

    <div
      *ngIf="addingButtonToLayoutResults.length || failedCreatingButtonNames.length || isWrongUrl"
      class="settings__logs"
    >
      <div *ngIf="failedCreatingButtonNames.length">
        <span class="settings__log-item" *ngFor="let layoutName of failedCreatingButtonNames">
          <span class="settings__log-cap">{{ layoutName.name }}</span> -
          <span class="error-msg settings__log-message">Oops! The Layout cannot be found.</span>
        </span>
      </div>
      <div *ngIf="addingButtonToLayoutResults.length">
        <span class="settings__log-item" *ngFor="let btnResult of addingButtonToLayoutResults">
          <!--{{btnResult.fullName.split('-')[1]}} - <span class="{{ btnResult.success ? 'success-msg' : 'error-msg' }}" [innerHTML]="btnResult.success ? 'Your button was created successfully.' : 'Your button was created successfully. <b>If it wasn’t added to your selected layout, try adding it manually.</b>'"></span>-->
          <span class="settings__log-cap">{{ btnResult.fullName.split('-')[1] }}</span> -
          <span class="settings__log-message">{{
            btnResult.success
              ? 'Your button was created successfully.'
              : 'Your button was created successfully. If it wasn’t added to your selected layout, try adding it manually.'
          }}</span>
        </span>
      </div>
      <div *ngIf="isWrongUrl">
        <span class="error-msg"
          >Oops! The button wasn’t created. Please check the link in the Redirect URL field.</span
        >
      </div>
    </div>

    <div class="settings__body">
      <button class="btn btn-sm btn-primary ml-0" (click)="openClosePopup('createButton', true)">
        Create button
      </button>
    </div>
  </div>
</div>

<sn-modal-popup [isShowModal]="is_creating_button_popup_open">
  <ng-container class="sn-modal-header">
    <h2 class="slds-text-heading_medium slds-hyphenate">Customize new button</h2>
  </ng-container>

  <ng-container class="sn-modal-content">
    <datalist id="sf-objects-list">
      <option *ngFor="let typeItem of sfObjectsList" value="{{ typeItem }}"></option>
    </datalist>
    <datalist id="sf-object-fields-list">
      <option *ngFor="let metaItem of sfCurrObjMetaList" value="{{ metaItem.name }}"></option>
    </datalist>

    <!--<datalist id="template-suggestion-list">-->
    <!--<option *ngFor="let tplSuggestionItem of templateSuggestionList" [value]="tplSuggestionItem.value">-->
    <!--</datalist>-->

    <div class="wizard">
      <div class="wizard__block">
        <div class="wizard__layouts layouts" *ngIf="is_creating_button_popup_open">
          <div class="layouts__header">
            <h3 class="wizard__cap layouts__title">Select the layouts for your button to appear on</h3>
            <div class="layouts__search">
              <input
                #wizardSearch
                (keyup)="search_layouts(wizardSearch.value, 'wizard-layouts-list')"
                class="layouts__search-input"
                placeholder="Search Layouts"
                type="text"
              />
              <span class="glyphicon glyphicon-search layouts__search-icon"></span>
            </div>
          </div>
          <div>
            <div class="layouts__list" id="wizard-layouts-list">
              <div
                class="layouts__item s-mark"
                *ngFor="let layoutItem of layoutsList"
                [attr.data-search-name]="layoutItem.name"
              >
                <label class="layouts__label" [attr.title]="layoutItem.name">
                  <input
                    class="layouts__checkbox"
                    type="checkbox"
                    #layoutCheckbox
                    (change)="addLayoutToUpdateFromWizard(layoutItem, layoutCheckbox, suggestionTplInput)"
                  />
                  <span>{{ layoutItem.name }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="wizard__block">
        <div class="wizard__cap">Choose button type</div>
        <div class="wizard__button-types" id="button-types-list" *ngIf="is_creating_button_popup_open">
          <label class="wizard__label">
            <input
              class="wizard__radio"
              type="radio"
              name="btn-type"
              (change)="changeButtonType(btnTypes.template, suggestionTplInput)"
              [attr.value]="btnTypes.template"
              checked
            /><span class="wizard__after-input">{{ btnTypes.template }}</span>
          </label>
          <label class="wizard__label">
            <input
              class="wizard__radio"
              type="radio"
              name="btn-type"
              (change)="changeButtonType(btnTypes.attachment, suggestionTplInput)"
              [attr.value]="btnTypes.attachment"
            /><span class="wizard__after-input">{{ btnTypes.attachment }}</span>
          </label>
          <label class="wizard__label">
            <input
              class="wizard__radio"
              type="radio"
              name="btn-type"
              (change)="changeButtonType(btnTypes.attachment_group, suggestionTplInput)"
              [attr.value]="btnTypes.attachment_group"
            /><span class="wizard__after-input">attachment group</span>
          </label>
          <label class="wizard__label">
            <input
              class="wizard__radio"
              type="radio"
              name="btn-type"
              (change)="changeButtonType(btnTypes.merge_attachments, suggestionTplInput)"
              [attr.value]="btnTypes.merge_attachments"
            /><span class="wizard__after-input">merge attachments</span>
          </label>
          <label class="wizard__label">
            <input
              class="wizard__radio"
              type="radio"
              name="btn-type"
              (change)="changeButtonType(btnTypes.quote, suggestionTplInput)"
              [attr.value]="btnTypes.quote"
              [disabled]="!isQuoteButtonCanBeChosen"
            /><span class="wizard__after-input">{{ btnTypes.quote }}</span>
          </label>
          <label class="wizard__label">
            <input
              class="wizard__radio"
              type="radio"
              name="btn-type"
              (change)="changeButtonType(btnTypes.bulk, suggestionTplInput)"
              [attr.value]="btnTypes.bulk"
            /><span class="wizard__after-input">{{ btnTypes.bulk }}</span>
          </label>
        </div>
      </div>

      <div class="wizard__block" *ngIf="selectedButtonType === btnTypes.bulk">
        <div class="wizard__cap">Select object for bulk invite</div>
        <div class="wizard__additional-params">
          <div class="form-group">
            <input
              type="text"
              class="sn-sf-input full-width"
              placeholder="SELECT_OBJECT"
              (input)="onChangeSfObjectType()"
              [(ngModel)]="selectedObjectTypeForBulk"
              list="sf-objects-list"
            />
          </div>
          <div class="form-group">
            <div class="wizard__cap">Select record field for bulk invite email</div>
            <div *ngIf="!sfCurrObjMetaList.length">
              <input
                type="text"
                class="sn-sf-input full-width"
                [(ngModel)]="selectedObjectFieldForBulk"
                placeholder="SALESFORCE_FIELD_NAME"
                [disabled]="!selectedObjectTypeForBulk.length"
              />
            </div>
            <div *ngIf="sfCurrObjMetaList.length" data-label="Select type">
              <div class="slds-truncate" title="Select type">
                <input
                  type="text"
                  class="sn-sf-input full-width select"
                  [(ngModel)]="selectedObjectFieldForBulk"
                  list="sf-object-fields-list"
                  autocomplete="off"
                  placeholder="SALESFORCE_FIELD_NAME"
                  [disabled]="!selectedObjectTypeForBulk.length"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="wizard__block"
        [hidden]="
          selectedButtonType == btnTypes.quote ||
          selectedButtonType == btnTypes.attachment_group ||
          selectedButtonType == btnTypes.merge_attachments
        "
      >
        <div class="wizard__cap">Preselected document <span class="wizard__optional">(optional)</span></div>
        <div class="wizard__additional-params">
          <div class="form-group">
            <div
              class="like-select"
              [ngClass]="{ 'no-arrow': selectedButtonType === btnTypes.attachment }"
              #suggestionTplSelector
            >
              <input
                #suggestionTplInput
                type="text"
                class="sn-sf-input full-width"
                [attr.placeholder]="
                  'WRITE ' +
                  (selectedButtonType === btnTypes.attachment
                    ? 'ATTACHMENT_ID VALUE'
                    : 'TEMPLATE NAME OR TEMPLATE_ID')
                "
                (input)="filteringTemplateSuggestion(suggestionTplInput.value)"
                (focus)="suggestionTplSelector.classList.add('open')"
                (blur)="onBlurSuggestionTplInputHandler(suggestionTplInput, suggestionTplSelector)"
              />
              <div
                class="like-select__options"
                [hidden]="
                  selectedButtonType === btnTypes.attachment || filteredTemplateSuggestionList.length == 0
                "
              >
                <span
                  *ngFor="let tplSuggestionItem of filteredTemplateSuggestionList"
                  [ngClass]="{
                    active:
                      chosenPreselectedDocument && chosenPreselectedDocument.value === tplSuggestionItem.value
                  }"
                  (click)="chooseTplHandler(tplSuggestionItem, suggestionTplSelector, suggestionTplInput)"
                  title="id&nbsp;=&nbsp;{{ tplSuggestionItem.value }}"
                  class="like-select__option"
                >
                  {{ tplSuggestionItem.label }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="wizard__block">
        <div class="wizard__cap">Additional Parameters <span class="wizard__optional">(optional)</span></div>
        <div class="wizard__additional-params">
          <label class="wizard__label wizard__half light-grey">
            <input
              class="wizard__checkbox"
              type="checkbox"
              name="btn-options"
              value="redirect"
              [checked]="isCheckedAdditionalParam(redirect.value)"
              #redirect
              (change)="changeAdditionalParams(redirect)"
            /><span>redirect</span>
          </label>
          <label class="wizard__label wizard__half light-grey">
            <input
              class="wizard__checkbox"
              type="checkbox"
              name="btn-options"
              value="mobile"
              [checked]="isCheckedAdditionalParam(mobile.value)"
              #mobile
              (change)="changeAdditionalParams(mobile)"
            /><span>mobile</span>
          </label>
          <!--<label class="wizard__label">-->
          <!--<input class="wizard__checkbox" type="checkbox" name="btn-options" value="email"><span>email</span>-->
          <!--</label>-->
        </div>
      </div>

      <div class="wizard__block" *ngIf="redirect.checked">
        <div class="wizard__cap">Redirect URL <span class="wizard__optional">(optional)</span></div>
        <div class="form-group">
          <input
            class="sn-sf-input full-width"
            type="text"
            name="btn-options"
            placeholder="ENTER THE URL FOR REDIRECTING"
            [(ngModel)]="redirectUrl"
          />
        </div>
      </div>

      <div class="wizard__block">
        <div class="wizard__cap">Document Flow <span class="wizard__optional">(optional)</span></div>
        <div class="form-group">
          <!--<select name="templates-settings-list" class="full-width" #templatesSettingsList (change)="changeTemplateSetting(templatesSettingsList.value)">-->
          <!--<option value="">none</option>-->
          <!--<option *ngFor="let templateSettingItem of template_settings" [attr.value]="templateSettingItem.id" >{{templateSettingItem.setting_name}}</option>-->
          <!--</select>-->

          <div class="like-select" #suggestionTplSettingSelector>
            <input
              #suggestionTplSettingInput
              type="text"
              class="sn-sf-input full-width"
              placeholder="none"
              (input)="filteringTemplateSettingSuggestion(suggestionTplSettingInput.value)"
              (focus)="suggestionTplSettingSelector.classList.add('open')"
              (blur)="
                onBlurSuggestionTplSettingInputHandler(
                  suggestionTplSettingInput,
                  suggestionTplSettingSelector
                )
              "
            />
            <div
              class="like-select__options mb-30"
              [hidden]="filteredTemplateSettingsSuggestionList.length == 0"
            >
              <span
                class="like-select__option"
                (click)="
                  chooseTplSettingHandler(null, suggestionTplSettingSelector, suggestionTplSettingInput)
                "
                >none</span
              >
              <span
                *ngFor="let tplSuggestionItem of filteredTemplateSettingsSuggestionList"
                [ngClass]="{ active: chosenTplSetting && chosenTplSetting.id === tplSuggestionItem.id }"
                (click)="
                  chooseTplSettingHandler(
                    tplSuggestionItem,
                    suggestionTplSettingSelector,
                    suggestionTplSettingInput
                  )
                "
                class="like-select__option"
              >
                {{ tplSuggestionItem.setting_name }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <!--</div>-->
      <div class="wizard__block">
        <div class="wizard__cap">Enter a button name</div>
        <div class="form-group">
          <input type="text" class="sn-sf-input full-width" [(ngModel)]="selectedCustomButtonName" />
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container class="sn-modal-footer">
    <button
      class="btn btn-sm btn-primary"
      (click)="generateCustomButton(); clearInputs([suggestionTplSettingInput, suggestionTplInput])"
      [disabled]="isCreateButtonDisabled()"
    >
      Create button
    </button>
    <button
      class="btn btn-neutral"
      (click)="
        openClosePopup('createButton', false); clearInputs([suggestionTplSettingInput, suggestionTplInput])
      "
    >
      Cancel
    </button>
  </ng-container>
</sn-modal-popup>
